import { render } from "./IconElectraLights.vue?vue&type=template&id=a9a989c2"
import script from "./IconElectraLights.vue?vue&type=script&lang=js"
export * from "./IconElectraLights.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__